import ConstantData from '../providers/json/constants.json';

// INFO: Contains all module names. Used to load templates.
export const MODULES = ConstantData.modules;

// INFO: Contains all error codes
export const ERRORS = ConstantData.errors;

const URLS = ConstantData.urls;

export const VALIDATIONS = ConstantData.validations;

export const ROUTE_NAMES = ConstantData.routes;

export const STORAGE_KEYS = ConstantData.storageKeys;

export const GEOLOCATION_API = 'https://freegeoip.app/json/';

export const VFS_GLOBAL_URL = 'https://www.vfsglobal.com/en/general';

export const PATHS = {
  assets: { images: `assets/images/$TENENT` }
};
export const DASHBOAR_TAB_KEYS = ['InProgress', 'Active', 'Previous'];

// @dynamic
export class Constants {
  public static get key() {
    return ConstantData.secretKey;
  }

  public static get schema() {
    return ConstantData.urls.schema;
  }

  public static get api() {
    return ConstantData.urls.api;
  }

  public static get modules() {
    return ConstantData.modules;
  }

  public static get data() {
    return ConstantData.urls.data;
  }

  public static get schemaKeys() {
    return ConstantData.schemaKeys;
  }

  public static get schemaValues() {
    return ConstantData.schemaValues;
  }

  public static get controls() {
    return ConstantData.controls;
  }

  public static get formSchemaType() {
    return ConstantData.formSchemaType;
  }

  public static get fileName() {
    return ConstantData.fileName;
  }

  public static get documentName() {
    return ConstantData.documentList;
  }

  public static get status() {
    return ConstantData.status;
  }

  // public static get routes() { return ConstantData.routes; }

  public static GET_MODULE_DATA = ConstantData.schemaValues;

  public static ALL = 'ALL';

  public static JSON_FILE_FORMAT = '.json';

  public static PAYMENT_GATEWAY = ConstantData.paymentGateway;

  public static ASSETS_PATH = ConstantData.assetsPath;

  public static NAVBAR_EXCEPTION_LIST = [
    ROUTE_NAMES.DASHBOARD,
    ROUTE_NAMES.PAYMENT_CONFIRMATION,
    ROUTE_NAMES.ADDITIONAL_DOCUMENT,
    ROUTE_NAMES.REVIEW_APPLICATION,
    ROUTE_NAMES.PAYMENT_GATEWAY,
    ROUTE_NAMES.ADD_APPLICANT
  ];

  public static REVIEW_APP_EXCEPTION_LIST = [MODULES.DOCUMENT_UPLOAD, MODULES.REVIEW_PAYMENT];

  public static SAVE_AS_DRAFT_EXCEPTION_LIST = [Constants.modules.ELIGIBILITY_CRITERIA];

  public static BUTTON_CONTROLS_LIST = [Constants.controls.Button, Constants.controls.Dual_button, Constants.controls.Multi_button];

  public static DROPDOWNS_LIST = [Constants.controls.Dropdown, Constants.controls.SearchableDropdown];

  public static LEFT_PANEL_EXCEPTION_LIST = [
    ROUTE_NAMES.DASHBOARD,
    ROUTE_NAMES.ADDITIONAL_DOCUMENT,
    ROUTE_NAMES.PAYMENT_GATEWAY,
    ROUTE_NAMES.PAYMENT_CONFIRMATION,
    ROUTE_NAMES.REVIEW_APPLICATION,
    ROUTE_NAMES.ADD_APPLICANT
  ];

  public static MODULE_BUCKET = {
    b1: [
      MODULES.ELIGIBILITY_CRITERIA,
      MODULES.DOCUMENT_UPLOAD,
      MODULES.PASSPORT_DETAILS,
      MODULES.APPLICANT_DETAILS,
      MODULES.TRAVEL_DETAILS,
      MODULES.ACCOMODATION_DETAILS,
      MODULES.REVIEW_PAYMENT
    ],
    b2: [MODULES.ELIGIBILITY_CRITERIA, MODULES.DOCUMENT_UPLOAD, MODULES.APPLICANT_DETAILS, MODULES.TRAVEL_DETAILS, MODULES.REVIEW_PAYMENT],
    b3: [
      MODULES.ELIGIBILITY_CRITERIA,
      MODULES.DOCUMENT_UPLOAD,
      MODULES.PASSPORT_DETAILS,
      MODULES.TRAVEL_DETAILS,
      MODULES.ADDITIONAL_DETAILS,
      MODULES.REVIEW_PAYMENT
    ],
    b4: [MODULES.ELIGIBILITY_CRITERIA, MODULES.PASSPORT_DETAILS, MODULES.REVIEW_PAYMENT],
    b5: [MODULES.ELIGIBILITY_CRITERIA, MODULES.DOCUMENT_UPLOAD, MODULES.PASSPORT_DETAILS, MODULES.REVIEW_PAYMENT]
  };

  public static DROP_DOWN_EXCLUDE_ROUTE = [
    ROUTE_NAMES.PAYMENT_GATEWAY,
    ROUTE_NAMES.PAYMENT_CONFIRMATION,
    ROUTE_NAMES.LOGIN,
    ROUTE_NAMES.ON_BOARDING,
    ROUTE_NAMES.TRACK_STATUS,
    ROUTE_NAMES.NOT_FOUND
  ];

  public static HEADER_EXCLUDE_ROUTE = [ROUTE_NAMES.NOT_FOUND];

  public static FOOTER_EXCLUDE_ROUTE = [ROUTE_NAMES.NOT_FOUND];

  public static CLIENT_CSS_EXCLUDE_ROUTE = ['precheck'];

  public static GET_PRODUCT_CONFIG_FLAG = ConstantData.productConfigFlags;

  public static get cacheApi() {
    return ConstantData.urls.cacheApi;
  }
}
